import * as Yup from "yup";

const ValidationSchema = Yup.object<any>().shape({
  textName: Yup.string().required(
    "US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALUE_INTO_THE_FIELD"
  ),
});

export default ValidationSchema;